export interface OnboardingSlide {
  videoUrl?: string;
  imgUrl?: string;
  lottieUrl?: string;
  title: string;
  description: string;
}

export type OnboardingType =
  | "contract"
  | "booking"
  | "loading"
  | "shipping"
  | "file"
  | "partner"
  | "supply"
  | "importStatus";

// 온보딩 콘텐츠의 미디어 파일들
export const ONBOARDING_MEDIA: Record<
  OnboardingType,
  Array<{
    videoUrl?: string;
    imgUrl?: string;
    lottieUrl?: any;
  }>
> = {
  contract: [
    { lottieUrl: require("@/src/assets/onboarding/1_Contract.lottie") },
  ],
  booking: [{ lottieUrl: require("@/src/assets/onboarding/3_Booking.lottie") }],
  loading: [{ lottieUrl: require("@/src/assets/onboarding/2_loading.lottie") }],
  shipping: [
    { lottieUrl: require("@/src/assets/onboarding/4_shipment.lottie") },
  ],
  file: [{ lottieUrl: require("@/src/assets/onboarding/5_filebox.lottie") }],
  partner: [
    { lottieUrl: require("@/src/assets/onboarding/8_Clientmanagement.lottie") },
  ],
  supply: [{ lottieUrl: require("@/src/assets/onboarding/7_supply.lottie") }],
  importStatus: [
    { lottieUrl: require("@/src/assets/onboarding/6_Importstatus.lottie") },
  ],
};
